module.exports = __webpack_public_path__ + "assets/images/drink_y.8591d4bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/drink_y.png
// module id = 705
// module chunks = 1